export const actionTypes = {
    GET_DATA_LOGGER_COMMANDS: 'dataLoggerCommand/GET_DATA_LOGGER_COMMANDS',
    GET_DATA_LOGGER_COMMANDS_REQUEST: 'dataLoggerCommand/GET_DATA_LOGGER_COMMANDS_REQUEST',
    GET_DATA_LOGGER_TRIGGER: 'dataLoggerCommand/GET_DATA_LOGGER_TRIGGER',
    GET_DATA_LOGGER_TRIGGER_REQUEST: 'dataLoggerCommand/GET_DATA_LOGGER_TRIGGER_REQUEST',
    GET_DATA_LOGGER_SUBSCRIBE_UNSUBSCRIBE: 'dataLoggerCommand/GET_DATA_LOGGER_SUBSCRIBE_UNSUBSCRIBE',
    GET_DATA_LOGGER_SUBSCRIBE_UNSUBSCRIBE_REQUEST: 'dataLoggerCommand/GET_DATA_LOGGER_SUBSCRIBE_UNSUBSCRIBE_REQUEST',
    CLEAR_STORE: 'dataLoggerCommand/CLEAR_STORE',
    GET_DATA_LOGGER_SUBSCRIBE_UNSUBSCRIBE_COMMANDS: 'dataLoggerCommand/GET_DATA_LOGGER_SUBSCRIBE_UNSUBSCRIBE_COMMANDS',
    GET_DATA_LOGGER_SUBSCRIBE_UNSUBSCRIBE_COMMANDS_REQUEST: 'dataLoggerCommand/GET_DATA_LOGGER_SUBSCRIBE_UNSUBSCRIBE_COMMANDS_REQUEST',
};

export const toggleOptions = {
    SUBSCRIBE: 'Subscribe',
    UNSUBSCRIBE: 'Unsubscribe'
};

export const loggerCommands = {
    TRIGGER: 'Trigger',
    STARTSTOP: 'StartStop',
    SUBSCRIBEUNSUBSCRIBE: 'SubscribeUnsubscribe',
    SUBSCRIBEUNANDSUBSCRIBE: 'SubscribeUnsubscribe',
    USERLOGGERDATA: 'Userdatalogger',
    DATALOGGER1: 'DataLogger1',
    DATALOGGER2: 'DataLogger2',
    DATALOGGER3: 'DataLogger3'
};

export const toggleTriggerOptions = {
    TRIGGER: 'Trigger',
    STOP: 'Stop',
};

export const commandIdOptions = {
    ENABLEPSL2LOGGER: 'EnablePsl2Logger',
    DISABLEPSL2LOGGER: 'DisablePsl2Logger',
    SUBSCRIBE: 'Subscribe',
    UNSUBSCRIBE: 'Unsubscribe',
    ENABLE: 'Enable',
    DISABLE: 'Disable',
    TRIGGER: 'Trigger'
};

export const unsubscribeDisableName = {
    DISABLEPSL2LOGGER: 'DISABLEPSL2LOGGER',
    UNSUBSCRIBE: 'UNSUBSCRIBE',
    DISABLE: 'DISABLE',
    USERLOGGERDATA: 'Userdatalogger'
};

export const commandPatternsActions = {
    TRIGGER: 'Trigger',
    START: 'Start',
    STOP: 'Stop',
    SUBSCRIBE: 'Subscribe',
    UNSUBSCRIBE: 'Unsubscribe',
    ENABLE: 'Enable',
    DISABLE: 'Disable',
    AMCOS: 'Amcos',
    UNICOS: 'Unicos',
    BLACKBOX: 'BlackBox',
    PSL2: 'Psl2',
};
